import React from 'react';
import { CheckCircle, Award, Target, Zap, LineChart } from 'lucide-react';

const differentials = [
  'Uso de dados e tecnologia para gerar eficiência',
  'Soluções personalizadas, adaptadas à realidade de cada empresa',
  'Experiência prática no setor logístico',
  'Automação e inteligência artificial aplicadas à logística'
];

const achievements = [
  {
    title: 'Otimização de Roteirização e Redução de Custos',
    description: 'Criamos um sistema de roteirização inteligente, que permite reduzir quilômetros rodados e melhorar o tempo de entrega. Empresas que implementaram essa tecnologia conseguiram reduzir os custos logísticos em até 20%.'
  },
  {
    title: 'Implementação de Soluções em IA para Logística',
    description: 'Desenvolvemos modelos baseados em inteligência artificial e machine learning para prever a demanda de transporte, identificar padrões de entrega e sugerir ajustes operacionais antes que problemas aconteçam.'
  },
  {
    title: 'Gestão de Frete e Redução de Despesas',
    description: 'Criamos metodologias para análise de frete que permitiram clientes identificarem economias ocultas, ajustarem suas negociações com transportadoras e adotarem um modelo de frete mais estratégico.'
  },
  {
    title: 'Análises de Clusters e Centros de Gravidade',
    description: 'Implementamos estudos detalhados para empresas entenderem onde abrir novos centros de distribuição e como reduzir custos de última milha, garantindo um atendimento mais rápido e eficiente.'
  }
];

export default function About() {
  return null;
}